import { render } from "./money_to_user_items.vue?vue&type=template&id=47bb00c3&scoped=true"
import script from "./money_to_user_items.vue?vue&type=script&lang=js"
export * from "./money_to_user_items.vue?vue&type=script&lang=js"

import "./money_to_user_items.vue?vue&type=style&index=0&id=47bb00c3&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47bb00c3"]])

export default __exports__